module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "part-h"
  }, [_c('span', [_vm._v("ENTERING THE CIRCLE")])]), _vm._v(" "), _c('p', {
    staticClass: "part-para"
  }, [_c('i', [_vm._v("So [Jesus] told us to form a circle, holding one another’s hands, and himself stood in the middle and said, “Answer Amen to me.” So he began to sing and to say …")])]), _vm._v(" "), _c('p', {
    staticClass: "part-left2b0011"
  }, [_c('i', [_vm._v("Dance, all of you.…")])]), _vm._v(" "), _c('p', {
    staticClass: "part-left2c00001"
  }, [_c('i', [_vm._v("To the universe belongs the dancer")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "part-left2c00001"
  }, [_c('i', [_vm._v("He who does not dance does not know what happens.…")])]), _vm._v(" "), _c('p', {
    staticClass: "part-left2b0011"
  }, [_c('i', [_vm._v("Now if you follow my dance, see yourself in me who am speaking")]), _vm._v(",")]), _vm._v(" "), _c('p', {
    staticClass: "part-left2c00001"
  }, [_c('i', [_vm._v("And when you have seen what I do, keep silence about my mysteries")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "part-left2b0011"
  }, [_c('i', [_vm._v("I leaped: but do you understand the whole?")])]), _vm._v(" "), _c('p', {
    staticClass: "part-left2d"
  }, [_vm._v("—Acts of John, New Testament Apocrypha")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a395013","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/part02.vue
// module id = 81
// module chunks = 0